import { Node, mergeAttributes } from '@tiptap/core'
import { ReactNodeViewRenderer } from '@tiptap/react'
import DfComponent from './DfComponent'

const DfNode = Node.create({
  name: 'dfNode',
  group: 'inline',
  inline: true,
  atom: true,
  selectable: true,
  draggable: true,

  addAttributes() {
    return {
      dfName: {
        default: '',
        parseHTML: element => element.getAttribute('data-df-name'),
        renderHTML: attributes => {
          if (!attributes.dfName) {
            return {}
          }
          return { 'data-df-name': attributes.dfName }
        }
      }
    }
  },

  parseHTML() {
    return [
      {
        tag: 'span[data-df-node]',
        getAttrs: node => {
          if (node instanceof HTMLElement) {
            const name = node.getAttribute('data-df-name')
            return name ? { dfName: name } : {}
          }
          return {}
        }
      }
    ]
  },

  renderHTML({ HTMLAttributes }) {
    return [
      'span',
      mergeAttributes(HTMLAttributes, { 'data-df-node': '' }),
      `{{df '${HTMLAttributes.dfName}'}}`
    ]
  },

  addNodeView() {
    return ReactNodeViewRenderer(DfComponent)
  }
})

export default DfNode
